import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Inria Sans;
`;
export const StyledInput = styled.input`
  background-color: #f3f3f3;
  width: ${(props) => (props.fullWidth ? "100%" : "auto")};
  border: none;
  outline: none;
  padding: 0.4rem 0.6rem;
`;
export const StyledLabel = styled.label`
  font-weight: 700;
`;

const CheckoutFormTextField = ({
  label,
  containerProps,
  fullWidth,
  labelProps,
  ...props
}) => {
  return (
    <Wrapper {...containerProps}>
      <StyledLabel {...labelProps}>{label}</StyledLabel>
      <StyledInput {...props} fullWidth={fullWidth} />
    </Wrapper>
  );
};

CheckoutFormTextField.defaultProps = {
  label: "No label given",
  fullWidth: true,
  containerProps: {},
  labelProps: {},
};

export default CheckoutFormTextField;
